import { getTokenFromLocalStorage } from '@/auth';
import messageToaster from '@/helpers/messageToaster';
import styles from '@/pages//styles.less';
import { Result } from '@/types/base';
import { ReactNode } from 'react';
import type { ResponseError } from 'umi-request';
import { extend } from 'umi-request';
import Guid from './Guid';

const msg = 'Gabimet qe ndodhen: ';

export const errorInterface = ({ errors, description, metadata }: ResponseError['data']) => {
    const traceId = metadata?.shift()?.content;

    let descNode: ReactNode;
    if (!description) descNode = <span>{msg}</span>;
    else
        descNode = (
            <>
                <span>{msg}</span>
                <br />
                <span>{description}</span>
            </>
        );

    const errorNodes = errors?.map((error: { key: string; content: string }, index: number) => (
        <li key={index}>{`${index + 1}.${error.key.charAt(0).toUpperCase() + error.key.slice(1)} : ${error.content}`}</li>
    ));

    const instanceKey = Guid.create();

    messageToaster({
        content: (
            <>
                {descNode}
                <ul className={styles.list}>{errorNodes}</ul>
                {traceId}
            </>
        ),
        instanceKey,
    });
};

export const baseErrorHandler = (error: ResponseError | any) => {
    const errorStatusCode: number = error.response?.status;
    // Return if not authetincated, to fix some glitches with error-popup
    if (errorStatusCode === 401) {
        return {
            data: null,
        } as Result<null>;
    }
    if (error.data && Object.keys(error?.data)?.length > 0) {
        errorInterface(error.data);
    } else {
        messageToaster({
            content: (
                <>
                    <div>Ndodhi një gabim:</div>
                    <div>Diçka shkoi keq. Ju lutemi kontaktoni departamentin e IT-së!</div>
                </>
            ),
        });
    }
    throw error;
};

const request = extend({
    prefix: API_HOST,
    errorHandler: baseErrorHandler,
});

export const request_v2 = extend({
    prefix: `${API_HOST.replace('v1', 'v2')}`,
    errorHandler: baseErrorHandler,
});

request_v2.interceptors.request.use(
    (url, options) => {
        const headers = { Authorization: `Bearer ${getTokenFromLocalStorage()}` };
        return { url, options: { ...options, headers } };
    },
    { global: false }
);

request.interceptors.request.use(
    (url, options) => {
        const headers = { Authorization: `Bearer ${getTokenFromLocalStorage()}` };
        return { url, options: { ...options, headers } };
    },
    { global: false }
);

export default request;

// request.interceptors.response.use(async (response, options) => {
//   if(response.ok) {
//     return await response.clone().json();
//   }
//   throw await response.clone().json();
// }, { global: false });
